<div class="container">
  <h3 class="title">
    Impressum
  </h3>
  <div class="text">
    <p>
      {{'Company name:' | trans: 'companyName'}}<br>
      {{ form.companyDetails.companyName }}
    </p>
    <p>
      {{'Company emal:' | trans: 'companyEmail'}}<br>
      {{ form.companyDetails.supportEmail }}
    </p>
    <p>
      {{'Company address:' | trans: 'companyAddress'}}<br>
      <span class="no-select">
        {{ form.companyDetails.companyAddress }}
      </span>
    <p>
  </div>
</div>
